import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistGetProfileAboutRequest } from '@/shared/api/requests/artist/about/get/request';
import { artistGetProfileAbout } from '@/shared/api/requests/artist/about/get/request';

export const useArtistProfileAboutQuery = (
  params: ArtistGetProfileAboutRequest,
  settings?: QuerySettings<typeof artistGetProfileAbout>
) =>
  useQuery({
    queryKey: ['ArtistProfileAbout', params.profileId],
    queryFn: () =>
      artistGetProfileAbout({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
